import type { StepType } from "@reactour/tour";
import welcome from "./welcome";
import aiDemo from "./aiDemo";
import editElement from "./editElement";
import revealStructure from "./revealStructure";
import whatNext from "./whatNext";

/** Steps array carrying a per-step section label, so tour analytics can report
 * the 5 meaningful phases instead of the ~34 raw reactour micro-steps (the
 * scripted AI demo auto-advances through many). Read by TourAnalyticsBridge. */
export type SectionedSteps = StepType[] & { __sections?: string[] };

export const aiFirstTourSteps = (hostId: string): SectionedSteps => {
	const sections: [string, StepType[]][] = [
		["welcome", welcome],
		["ai_demo", aiDemo(hostId)],
		["edit_element", editElement(hostId)],
		["reveal_structure", revealStructure(hostId)],
		["what_next", whatNext],
	];
	const steps: SectionedSteps = [];
	const bySection: string[] = [];
	for (const [name, arr] of sections) {
		for (const step of arr) {
			steps.push(step);
			bySection.push(name);
		}
	}
	steps.__sections = bySection;
	return steps;
};
